/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ActionInstance} from "../../models/action-instance";
import {Component, Input, EventEmitter, Output} from "@angular/core";
import {Event} from "../../models/event";

declare var $: any;

@Component({
  selector: 'app-rule-editor-action-editor',
  templateUrl: './rule-editor-action-editor.component.html'
})
export class RuleEditorActionEditorComponent {

  @Input()
  mUniqueIndex: number;

  @Input()
  mAction: ActionInstance;

  @Input()
  mEvent: Event;  
    
  @Output()
  removeAction = new EventEmitter<ActionInstance>();

  getIconForAction(): string {
    if (this.mAction.action.glyph != null && this.mAction.action.glyph.length > 0) {
      return this.mAction.action.glyph;
    } else {
      return 'fa-question';
    }
  }

  setBodyVisible(visible: boolean): void {
    console.log("setBodyVisible(" + visible + ") - Unique Index: " + this.mUniqueIndex);
    if (visible) {
      $("#actionDetailBody_" + this.mUniqueIndex).show();
    } else {
      $("#actionDetailBody_" + this.mUniqueIndex).hide();
    }
  }

}
